var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.5C9.41421 0.5 9.75 0.835786 9.75 1.25V11.4393L12.4697 8.71967C12.7626 8.42678 13.2374 8.42678 13.5303 8.71967C13.8232 9.01256 13.8232 9.48744 13.5303 9.78033L9.53033 13.7803L9 14.3107L8.46967 13.7803L4.46967 9.78033C4.17678 9.48744 4.17678 9.01256 4.46967 8.71967C4.76256 8.42678 5.23744 8.42678 5.53033 8.71967L8.25 11.4393V1.25C8.25 0.835786 8.58579 0.5 9 0.5ZM1.75 13.25C1.75 12.8358 1.41421 12.5 1 12.5C0.585786 12.5 0.25 12.8358 0.25 13.25V15.25C0.25 16.7688 1.48122 18 3 18H15C16.5188 18 17.75 16.7688 17.75 15.25V13.25C17.75 12.8358 17.4142 12.5 17 12.5C16.5858 12.5 16.25 12.8358 16.25 13.25V15.25C16.25 15.9404 15.6904 16.5 15 16.5H3C2.30964 16.5 1.75 15.9404 1.75 15.25V13.25Z",
    fill: "#476bf0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.952ee57d0a3f825171bc91e9230b8ca7.svg";
export { ForwardRef as ReactComponent };